import { ActivatedRouteSnapshot, Data, Params } from '@angular/router';
import { ISelectOptions } from '../models/form/select';
import { Constants } from './constants';

export class Utils {
  /**
   * Displays the original copyright year or the range from that year to the current year.
   */
  static getCopyrightYear(): string {
    return Constants.initialCopyrightYear >= new Date().getFullYear()
      ? `${new Date().getFullYear()}`
      : `${Constants.initialCopyrightYear} - ${new Date().getFullYear()}`;
  }

  static truncateString(input: string, maxLength?: number): string {
    const currentMaxLength = maxLength ? maxLength : 50;

    if (input.length <= currentMaxLength) {
      return input;
    }

    return `${input.slice(0, currentMaxLength)}...`;
  }

  static buildFormData(
    files: FileList,
    props?: ISelectOptions[],
    filePropName: string = 'files',
  ): FormData {
    const fileListFormData: FormData = new FormData();
    if (props?.length) {
      props.forEach((prop) => appendToFormData(prop.name, prop.value));
    }

    // FileList does not have access to Array methods like `forEach()`
    /* tslint:disable:prefer-for-of */
    if (files?.length > 0) {
      for (let i: number = 0; i < files.length; i++) {
        appendToFormData(filePropName, files[i]);
      }
    }

    return fileListFormData;

    function appendToFormData(
      propertyName: string,
      value: string | Blob,
    ): void {
      fileListFormData.append(propertyName, value);
    }
  }

  static getAllParams(route: ActivatedRouteSnapshot) {
    const params: Params = {};
    if (route.parent) {
      Object.assign(params, { ...this.getAllParams(route.parent) });
    }
    Object.assign(params, { ...route.params });
    return params;
  }

  static getAllData(route: ActivatedRouteSnapshot) {
    const data: Data = {};
    if (route.parent) {
      Object.assign(data, { ...this.getAllData(route.parent) });
    }
    Object.assign(data, { ...route.data });
    return data;
  }
}
